import * as React from 'react';
import Badge from '@telia-front/badge';
import Image from '@telia-front/image';
import PropsChecker from '@telia-front/props-checker';
const Magazine = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "Magazine", defaultValueName: "defaultChecked", valueName: "checked", onChangeNames: "onChange", isComponentDisabled: props.disabled },
        React.createElement(MagazineInner, Object.assign({}, props))));
};
export default Magazine;
export class MagazineInner extends React.Component {
    constructor() {
        super(...arguments);
        this.onChange = (event) => {
            const checked = event.currentTarget.checked;
            if (this.props.onChange) {
                this.props.onChange(checked);
            }
        };
    }
    getTitle() {
        return (React.createElement("span", { className: "magazine__header" },
            React.createElement("span", { className: "magazine__title" }, this.props.title),
            this.props.info && React.createElement("span", { className: "magazine__info" }, this.props.info)));
    }
    BEM() {
        const classArray = ['magazine'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.disabled) {
            classArray.push('is-disabled');
        }
        return classArray.join(' ');
    }
    imageBEM() {
        const classArray = ['magazine__img'];
        if (this.props.image && this.props.image.className) {
            classArray.push(this.props.image.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            React.createElement("div", { className: "magazine__inner" },
                React.createElement("input", Object.assign({}, this.props.input, { disabled: this.props.disabled, type: "checkbox", id: this.props.id, onChange: this.onChange, className: "magazine__input", checked: this.props.checked, defaultChecked: this.props.defaultChecked })),
                React.createElement("label", { htmlFor: this.props.id, className: "magazine__label" },
                    this.getTitle(),
                    React.createElement("span", { className: "magazine__image" }, this.props.image && React.createElement(Image, Object.assign({}, this.props.image, { className: this.imageBEM() }))),
                    React.createElement(Badge, { className: "magazine__checked-badge", icon: "#check", size: "large", purpose: "selected" })))));
    }
}
